import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_household: FaireCategoryEntity = {
  token: "cat_home-decor-household",
  type: "category",
  name: "Household supplies & DIY",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/household-supplies-diy",
  childCategoryTokens: [
    "cat_household-all",
    "cat_household-cleaning",
    "cat_household-dish",
    "cat_household-laundry",
    "cat_household-tools",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
